import { Component, OnInit, DoCheck } from '@angular/core';
import { ArticleService } from "../../../../services/article.service";
import { ActivatedRoute, Router } from '@angular/router';
import { GLOBAL } from "../../../../services/GLOBAL";
import { UserService } from 'src/app/services/user.service';

interface HtmlInputEvent extends Event{
  target : HTMLInputElement & EventTarget;
}

declare var jQuery:any;
declare var $:any;

@Component({
  selector: 'app-edit-article',
  templateUrl: './edit-article.component.html',
  styleUrls: ['./edit-article.component.css']
})
export class EditArticleComponent implements OnInit,DoCheck {

  public id;
  public article : any = {};
  public msm_error;
  public msm_success;
  public file :File;
  public imgSelect : {banner: String | ArrayBuffer, mobile_banner: String | ArrayBuffer} = {banner: '', mobile_banner: ''};
  public url;
  public identity;
  public config;


  constructor(
    private _articleService : ArticleService,
    private _route : ActivatedRoute,
    private _router : Router,
    private _userService: UserService,
  ) {
    this.url = GLOBAL.url;
    this.identity = this._userService.getIdentity();
  }

  ngOnInit(): void {

    if(this.identity){
      if(this.identity.role == '12$MAhAAdPTi92gVknt8QyKIuEzcRYM6pa8.3RwTjFMfMwJvs2Jube'){
        this.config = {
          height: 800,
          menubar: 'file edit view insert format tools table help',
          language : 'es',
          skin: 'material-classic',
          plugins: [
            'print preview fullpage paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons spellchecker mediaembed pageembed linkchecker powerpaste formatpainter casechange'
          ],
          toolbar:
            'casechange undo redo  bold italic underline strikethrough  fontselect fontsizeselect formatselect alignleft aligncenter alignright alignjustify outdent indent numlist bullist  forecolor backcolor removeformat pagebreak charmap emoticons fullscreen preview save print insertfile image media template link anchor codesample fullpage ltr rtl styleselect pageembed formatpainter',

        };
        this._route.params.subscribe(
          params=>{
            this.id = params['id'];
            this._articleService.list_one(this.id).subscribe(
              response=>{
                this.article = response.article;

              },
              error=>{

              }
            )
          }
        );
      }
      else{
        this._router.navigate(['/']);
      }
    }else{
      this._router.navigate(['/']);
    }



  }

  ngDoCheck(): void {

  }




  onSubmit(articleForm){
    if(articleForm.valid){

      let data = {
        nombre: articleForm.value.nombre,
        banner: this.article.banner,
        mobile_banner: this.article.mobile_banner,
        _id: this.article._id,
        body: articleForm.value.body
      }




      this._articleService.update(data).subscribe(
        response =>{
          this._router.navigate(['/admin/articles']);

        },
        error=>{
          this.msm_error = error;
        }
      );

    }else{
      this.msm_error = 'Complete correctamente el formulario por favor.';
    }
  }

  imgSelected(event: HtmlInputEvent, fieldName){
    if(event.target.files  && event.target.files[0]){
      const reader = new FileReader();
      reader.onload = e => this.imgSelect[fieldName]= reader.result;
      reader.readAsDataURL(<File>event.target.files[0]);
      this.article[fieldName] = <File>event.target.files[0];

    }

  }

  close_alert(){
    this.msm_error = '';
    this.msm_success = '';
  }

}
